import { render, staticRenderFns } from "./RedirectButton.vue?vue&type=template&id=03eb9ad6&scoped=true"
import script from "./RedirectButton.vue?vue&type=script&lang=js"
export * from "./RedirectButton.vue?vue&type=script&lang=js"
import style0 from "./RedirectButton.vue?vue&type=style&index=0&id=03eb9ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb9ad6",
  null
  
)

export default component.exports